import cn from 'classnames';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

import { DesktopHeader, MobileHeader } from '@sravni/react-header';
import { GlobalSearch } from '@sravni/react-search';
import { useBoolean, useIsMobile } from '@sravni/react-utils';

import { useCurrentLocation } from '../../hooks/locations';
import { useSiteSettings } from '../../hooks/sitesettings';
import { useUser } from '../../hooks/users';

import styles from './header.module.scss';

const searchUrl = getConfig().publicRuntimeConfig.publicUrl;

export default function Header() {
  const { asPath } = useRouter();
  const settings = useSiteSettings();
  const isMobile = useIsMobile();
  const user = useUser();
  const currentLocation = useCurrentLocation();

  const [isScrolled, setScrolled] = useBoolean(false);

  const ComponentToRender = isMobile ? MobileHeader : DesktopHeader;

  const handleScroll = () => {
    if (window.scrollY > 0) {
      setScrolled.on();
    } else {
      setScrolled.off();
    }
  };

  useEffect(() => {
    document.addEventListener('scroll', handleScroll);

    return () => document.removeEventListener('scroll', handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={cn(styles.headerWrapper, { [styles['headerWrapper--scrolled']]: isScrolled })}>
      <ComponentToRender
        currentRegion={currentLocation}
        settings={settings.header}
        user={user}
        enableTheme
        search={<GlobalSearch searchServiceHost={searchUrl} asPath={asPath} />}
      />
    </div>
  );
}
